export const RANK_TRACKER_CAMPAIGNS_CONFIG_KEY = "RANK_TRACKING_CAMPAIGNS_CONFIG";
export const RANK_TRACKER_DEMO_CAMPAIGNS_CONFIG_KEY = "RANK_TRACKING_DEMO_CAMPAIGNS_CONFIG";
export const RANK_TRACKER_LOCALE_CONFIGS_KEY = "RANK_TRACKING_LOCALE_CONFIG";

export const OVERVIEW_REPORT_PAGE = "ranktracker.overview";
export const TAGS_CAMPAIGN_REPORTS_PAGE = "ranktracker.tags";
export const PAGES_CAMPAIGN_REPORTS_PAGE = "ranktracker.pages";

export const NON_REPORTS_PAGES = ["home", "wizard", "settings"];

export const PAGE_SIZE_LARGE = 100;
export const PAGE_SIZE_SMALL = 10;

export const RT_EDIT_SETTINGS_STATE = "ranktracker.settings";
